export var SeverityLevelEnum;
(function (SeverityLevelEnum) {
    SeverityLevelEnum["HIGH"] = "high";
    SeverityLevelEnum["MEDIUM"] = "medium";
    SeverityLevelEnum["LOW"] = "low";
    SeverityLevelEnum["NONE"] = "none";
})(SeverityLevelEnum || (SeverityLevelEnum = {}));
//# sourceMappingURL=severity.js.map